// 多个页面可以共享一个服务端权限；运行时把权限别名展开为实际路由名。
export default function expandPermissionRights(rights, routes) {
  const expanded = new Set(rights || []);
  const visit = (items) => (items || []).forEach((route) => {
    if (route.meta && route.meta.permission && expanded.has(route.meta.permission) && route.name) {
      expanded.add(route.name);
    }
    visit(route.children);
  });
  visit(routes);
  return Array.from(expanded);
}
